import { render, staticRenderFns } from "./cefloreco-product-world.vue?vue&type=template&id=032e9fcf&scoped=true&"
import script from "./cefloreco-product-world.vue?vue&type=script&lang=js&"
export * from "./cefloreco-product-world.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-product-world.vue?vue&type=style&index=0&id=032e9fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e9fcf",
  null
  
)

export default component.exports